import { IState } from '../../../../../../store/types';
import { getTargetCaptions } from '../../../../../../store/videos/selectors';
import { ITargetCaptionsHOCOwnProps } from '../../../../../CaptionsContainer/TargetCaptions/hocs/types';
import {
  IPlayerListenerHolder,
  ITargetCaptionsEvents,
  ITargetCaptionsFields
} from '../../../../../CaptionsContainer/TargetCaptions/components/types';
import {
  getCurrentAudioId,
  getCurrentAudioKey,
  getSelectedNativeCaption,
  getSelectedTargetCaption
} from '../../../../../../store/current-video/selectors';
import {
  AudioPlayerStates,
  hocPropsCache,
  IHocPropsCacheStore
} from '../../../../../../types/common';
import {
  getAudioPlayerState,
  isShowTranslations
} from '../../../../../../store/general/selectors';
import { connect } from 'react-redux';
import { TargetCaptions } from '../../../../../CaptionsContainer/TargetCaptions/components/TargetCaptions';
import { AudioPlayerManager } from '../../../../../../effects/audioPlayer/audioPlayerManager';
import { TargetAudioCaptionsEvents } from './events';
import { getActiveGroupTargetLanguage, getAudioById } from '../../../../../../store/models/selectors';
import { TAudioType } from '../../../../../../store/models/types';
import { getLessonPlayback } from '../../../../selectors/getLessonPlayback';

const listenerHolder: IPlayerListenerHolder = {
  addListener: (listener: any) => {
    AudioPlayerManager.getInstance().addListener(listener);
  },
  removeListener: (listener: any) => {
    AudioPlayerManager.getInstance().removeListener(listener);
  }
}

const mapStateToProps = (
  dispatch: any
) => {
  const cacheStore: IHocPropsCacheStore<ITargetCaptionsFields> = {}

  return (
    state: IState,
    { elementRef, isSelectPopup }: ITargetCaptionsHOCOwnProps
  ): ITargetCaptionsFields => {
    const nativeLanguage = getSelectedNativeCaption(state);
    const targetLanguage = getSelectedTargetCaption(state);
    const solo = isSelectPopup || !nativeLanguage || nativeLanguage.code === targetLanguage?.code;
    const langCode = getSelectedTargetCaption(state)?.code || '';
    const playerActive = getAudioPlayerState(state) === AudioPlayerStates.PLAYING;
    const captions = getTargetCaptions(state)

    const groupLang = getActiveGroupTargetLanguage(state);

    const audioId = getCurrentAudioId(state);
    const audio = audioId ? getAudioById(state, audioId) : null;
    // media deleted by saveLevel (transcription): no player, so no per-line play buttons
    const playerExist = audio?.type === TAudioType.AUDIO && getLessonPlayback(state) === 'media';

    return hocPropsCache({
      elementRef,
      captions,
      videoId: getCurrentAudioKey(state),
      solo,
      langCode,
      playerActive,
      forwardCaptionIndex: -1,
      listenerHolder,
      showTranslations: isShowTranslations(state),
      groupLangName: groupLang?.name || '',
      playerExist
    }, cacheStore)
  };
}

const mapDispatchToProps = (
  dispatch: any,
  {onChangeActiveIndex, onCaptionMouseEnter, onCaptionMouseLeave}: ITargetCaptionsHOCOwnProps
): ITargetCaptionsEvents => ({
    onMouseEnter: () => dispatch(TargetAudioCaptionsEvents.onMouseEnter()),
    onMouseLeave: () => dispatch(TargetAudioCaptionsEvents.onMouseLeave()),
    onChangeActiveIndex: index => {
      onChangeActiveIndex(index);
    },
    onCaptionMouseEnter: index => onCaptionMouseEnter(index),
    onCaptionMouseLeave: index => onCaptionMouseLeave(index),
    onCaptionMouseDown: index => dispatch(TargetAudioCaptionsEvents.onCaptionMouseDown()),
    onCaptionPlay: (caption, isPause) => dispatch(TargetAudioCaptionsEvents.onCaptionPlay(caption, isPause)),
    onCaptionDblClick: (index, caption) => dispatch(TargetAudioCaptionsEvents.onCaptionDblClick(index, caption)),
  }
);

export const TargetAudioCaptionsHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(TargetCaptions);

TargetAudioCaptionsHOC.displayName = 'TargetAudioCaptionsHOC';
